export default __webpack_public_path__ + "static/media/1.71b33f14.png";